import { Injectable } from '@angular/core';

import { SyncEvent } from 'ts-events';

declare var window: any;


@Injectable()
export class AudioProvider {
	private static playingMedia: any = null;
	private static playingPath: string = null;

	private static recordingMedia: any = null;
	private static recordingPath: string = null;
	private static _isPlaying: boolean = false;
	private static _isRecording: boolean = false;

	/**
	Registrazione iniziata
	*/
	public static onStartRecording: SyncEvent<string> = new SyncEvent<string>();
	/**
	Riproduzione iniziata
	*/
	public static onStartPlaying: SyncEvent<string> = new SyncEvent<string>();
	/**
	Registrazione terminata
	*/
	public static onStopRecording: SyncEvent<string> = new SyncEvent<string>();
	/**
	Riproduzione terminata
	*/
	public static onStopPlaying: SyncEvent<string> = new SyncEvent<string>();

	/**
	Verifica sae la libreria sottostante (cordova plugin media) è disponibile.
	Nota: Potrebbe non esserlo in fase di inizializzazione e poi diventarlo
	*/
	public static get isAvailable(): boolean {
		return !!window.Media
	}

	/**
	Verifica se vi sia una riproduzione in corso
	*/
	public static get isPlaying(): boolean {
		return AudioProvider._isPlaying;
	};


	/**
	Verifica se vi sia una regitrazione in corso
	*/
	public static get isRecording(): boolean {
		return AudioProvider._isRecording;
	}
	/**
	Restituisce l'ultimo percorso nel quale è iniziata una regitrazione
	*/
	public static get lastRecordingPath(): string {
		return AudioProvider.recordingPath;
	}

	constructor(
	) { }

	/**
	Elimina i flag e le risorse per la riproduzione
	*/
	private static cleanPlaying() {
		AudioProvider._isPlaying = false;
		if (AudioProvider.playingMedia) {
			AudioProvider.playingMedia.release()
			AudioProvider.playingMedia = null;
		}
	}

	/**
	Elimina i flag e le risorse per la registrazione
	*/
	private static cleanRecording() {
		AudioProvider._isRecording = false;
		if (AudioProvider.recordingMedia) {
			AudioProvider.recordingMedia.release()
			AudioProvider.recordingMedia = null;
		}
	}

	/**
	Deregistra un eventuale listener
	*/
	public static detach(listener: any) {
		AudioProvider.onStartPlaying.detach(listener)
		AudioProvider.onStartRecording.detach(listener)
		AudioProvider.onStopPlaying.detach(listener)
		AudioProvider.onStopRecording.detach(listener)
	}


	public static async startPlaying(mediaPath: string): Promise<void> {
		let ready: Promise<any>[] = [];
		if (AudioProvider.isPlaying) {
			console.info('[AudioProvider.startPlaying()] Riproduzione già in corso, fermo la precedente riproduzione prima di proseguire..')
			ready.push(AudioProvider.stopPlaying());
		}

		return new Promise<void>((resolve, reject) => {
			Promise.all(ready).then(() => {
				AudioProvider.playingMedia = new window.Media(
					mediaPath,
					() => {//media success
						console.info("[AudioProvider.startPlaying()] Accesso al file da riprodurre: " + mediaPath);
					},
					e => {//media error
						/*
						MediaError.MEDIA_ERR_ABORTED = 1
						MediaError.MEDIA_ERR_NETWORK = 2
						MediaError.MEDIA_ERR_DECODE = 3
						MediaError.MEDIA_ERR_NONE_SUPPORTED = 4
						*/
						let errorType = 'Sconosciuto';
						if (e.code) {
							switch (e.code) {
								case 1:
									errorType = 'MEDIA_ERR_ABORTED';
									break;
								case 2:
									errorType = 'MEDIA_ERR_NETWORK';
									break;
								case 3:
									errorType = 'MEDIA_ERR_DECODE';
									break;
								case 4:
									errorType = 'MEDIA_ERR_NONE_SUPPORTED';
									break;
							}
							errorType = 'Codice ' + e.code + ': ' + errorType;
						}
						console.error("[AudioProvider.startPlaying()] Errore di tipo '" + errorType + "' accedendo al file da riprodurre: " + e.message, e);

						AudioProvider.stopPlaying();
						reject("Errore riproducendo l'audio")
					},
					status => {
						/*
						Media.MEDIA_NONE = 0;
						Media.MEDIA_STARTING = 1;
						Media.MEDIA_RUNNING = 2;
						Media.MEDIA_PAUSED = 3;
						Media.MEDIA_STOPPED = 4;
						*/
						console.debug('[AudioProvider.startPlaying()] Cambio stato, valore stato: ', status)
						switch (status) {
							case 0:
								console.info('Nessun media: MEDIA_NONE')
								break;
							case 1:
								console.info('Avviamento media: MEDIA_STARTING')
								AudioProvider.onStartPlaying.post(AudioProvider.playingPath)
								AudioProvider._isPlaying = true;
								break;
							case 2:
								console.info('Media in esecuzione: MEDIA_RUNNING')
								break;
							case 3:
								console.info('Media in pausa: MEDIA_PAUSED')
								break;
							case 4:
								console.info('Media terminato: MEDIA_STOPPED, rilascio le risorse del media..')
								AudioProvider.onStopPlaying.post(AudioProvider.playingPath)
								AudioProvider.cleanPlaying();
								break;
							default:
								console.warn('Status media non riconosciuto')
								break;
						}
					}
				);

				AudioProvider.playingPath = mediaPath;
				// Play audio
				AudioProvider.playingMedia.play();
				resolve()
			})
		})
	}

	/**
	Avvia la registrazione di un audio.
	E' opzionalmente possibile definire in anticipo la durata della registrazione, impostando maxMillisecs ad un valore intero positivo
	Se sta già registrando un audio ferma il precedente prima di proseguire.
	Nota: Android deve specificare un file .aac, gli altri sistemi .mp3
	*/
	public static async startRecording(savePath: string): Promise<string> {
		let ready: Promise<any>[] = [];
		if (AudioProvider.isRecording) {
			console.info('[AudioProvider.startRecording()] Registrazione già in corso, fermo la registrazione prima di proseguire..')
			ready.push(AudioProvider.stopRecording());
		}

		return new Promise<string>((resolve, reject) => {
			Promise.all(ready).then(() => {
				AudioProvider.recordingMedia = new window.Media(savePath,
					() => {
						console.info("[AudioProvider.startRecording()] Audio salvato in: " + savePath);
					},
					e => {
						/*
						MediaError.MEDIA_ERR_ABORTED = 1
						MediaError.MEDIA_ERR_NETWORK = 2
						MediaError.MEDIA_ERR_DECODE = 3
						MediaError.MEDIA_ERR_NONE_SUPPORTED = 4
						*/
						let errorType = 'Sconosciuto';
						if (e.code) {
							switch (e.code) {
								case 1:
									errorType = 'MEDIA_ERR_ABORTED';
									break;
								case 2:
									errorType = 'MEDIA_ERR_NETWORK';
									break;
								case 3:
									errorType = 'MEDIA_ERR_DECODE';
									break;
								case 4:
									errorType = 'MEDIA_ERR_NONE_SUPPORTED';
									break;
							}
							errorType = 'Codice ' + e.code + ': ' + errorType;
						}
						console.error("[AudioProvider.startRecording()] Errore di tipo '" + errorType + "' registrando l'audio: " + e.message, e);

						AudioProvider.stopRecording();
						reject("Errore registrando l'audio")
					},
					status => {
						/*
						Media.MEDIA_NONE = 0;
						Media.MEDIA_STARTING = 1;
						Media.MEDIA_RUNNING = 2;
						Media.MEDIA_PAUSED = 3;
						Media.MEDIA_STOPPED = 4;
						*/
						console.debug('[AudioProvider.startPlaying()] Cambio stato, valore stato: ', status)
						switch (status) {
							case 0:
								console.info('Nessun media: MEDIA_NONE')
								break;
							case 1:
								console.info('Avviamento registrazione: MEDIA_STARTING')
								AudioProvider.onStartRecording.post(AudioProvider.playingPath)
								AudioProvider._isRecording = true;
								break;
							case 2:
								console.info('Registrando media: MEDIA_RUNNING')
								break;
							case 3:
								console.info('Registrazione in pausa: MEDIA_PAUSED')
								break;
							case 4:
								console.info('Registrazione terminata: MEDIA_STOPPED, rilascio le risorse del media..')
								AudioProvider.onStopRecording.post(AudioProvider.recordingPath)
								AudioProvider.cleanRecording();
								break;
							default:
								console.warn('Status media non riconosciuto')
								break;
						}
					});

				AudioProvider.recordingPath = savePath;
				// Record audio
				AudioProvider.recordingMedia.startRecord();
				resolve(savePath);
			}).catch(e => {
				console.error("Errore fermando la registrazione in corso:", e);
				reject('Errore fermando la registrazione in corso');
			});
		})
	}

	public static stopPlaying(): Promise<boolean> {
		if (!AudioProvider.playingMedia) {//riproduzione non inizializzata
			return Promise.resolve(false);
		}
		AudioProvider.playingMedia.stop();
		AudioProvider.cleanPlaying();

		return Promise.resolve(true);
	}

	/**
	Ferma un'eventuale registrazione in corso
	WARN: Non mutuamente esclusivo
	*/
	public static stopRecording(): Promise<boolean> {
		if (!AudioProvider.recordingMedia) {//registrazione non inizializzata
			return Promise.resolve(false);
		}

		AudioProvider.recordingMedia.stopRecord();
		AudioProvider.cleanRecording();

		return Promise.resolve(true);
	}
}



// WEBPACK FOOTER //
// ./src/providers/audio/audio.ts